import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Hide the first-paint splash as soon as React has mounted the shell.
// Done on the next animation frame so there is no flash between splash and app.
requestAnimationFrame(() => {
  const el = document.getElementById("bos-splash");
  if (!el) return;
  el.classList.add("bos-fade");
  setTimeout(() => el.remove(), 300);
});

// PWA — register the service worker for offline + push
if ("serviceWorker" in navigator && process.env.NODE_ENV !== "test") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((e) => console.warn("[SW] register failed:", e));
  });
}
